import { useQuery } from "urql"

import { GetAlternativesListDocument, type GetAlternativesListQuery } from "@/graphql/codegen/graphql"

export type CompanyProductAlternative =
  GetAlternativesListQuery["companyProductAssociation"]["alternativesList"][number]

interface UseGetAlternativesListParams {
  companyProductAssociationLocationId: string | null | undefined
}

interface UseGetAlternativesListReturn {
  alternatives: CompanyProductAlternative[]
  isFetching: boolean
  refetch: () => void
}

export const useGetAlternativesList = ({
  companyProductAssociationLocationId,
}: UseGetAlternativesListParams): UseGetAlternativesListReturn => {
  const [{ data, fetching }, reexecuteQuery] = useQuery({
    query: GetAlternativesListDocument,
    variables: { companyProductAssociationLocationId: companyProductAssociationLocationId! },
    pause: !companyProductAssociationLocationId,
  })

  const alternatives = data?.companyProductAssociation?.alternativesList ?? []

  const refetch = () => reexecuteQuery({ requestPolicy: "network-only" })

  return { alternatives, isFetching: fetching, refetch }
}
